module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ds-agenda-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.eventDays), function(day) {
    return [_c('ds-agenda-day', _vm._g(_vm._b({
      key: day.dayIdentifier,
      attrs: {
        "read-only": _vm.readOnly,
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-agenda-day', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "column-day"
  }), _vm._v(" "), _c('col', {
    staticClass: "column-when"
  }), _vm._v(" "), _c('col', {
    staticClass: "column-event"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8262ea58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agenda.vue
// module id = 181
// module chunks = 0